import { apiFetch } from "./client";

const login = async ({ email, password, remember }) =>
  apiFetch("/api/auth/login", {
    method: "POST",
    body: JSON.stringify({ email, password, remember }),
  });

const forgotPassword = async ({ email }) => {
  const response = await apiFetch("/api/auth/forgot-password", {
    method: "POST",
    body: JSON.stringify({ email }),
  });

  if (response?.emailStatus === "failed") {
    const error = new Error(response?.emailError || "Unable to send reset email.");
    error.data = response;
    throw error;
  }

  return response;
};

export { login, forgotPassword };
